import { render } from "./QRCodeScanner.vue?vue&type=template&id=31fbe968&scoped=true"
import script from "./QRCodeScanner.vue?vue&type=script&lang=js"
export * from "./QRCodeScanner.vue?vue&type=script&lang=js"

import "./QRCodeScanner.vue?vue&type=style&index=0&id=31fbe968&scoped=true&lang=css"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fbe968"]])

export default __exports__